import React from "react";
import { Canvas } from "@react-three/fiber";

const SpinningCube = () => {
  return (
    <mesh rotation={[45, 45, 0]}>
      <boxGeometry attach="geometry" args={[2, 2, 2]} />
      <meshStandardMaterial attach="material" color="blue" />
    </mesh>
  );
};

const LoadingScreen = () => {
  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100">
      <Canvas style={{ width: "300px", height: "300px" }}>
        <ambientLight intensity={0.5} />
        <directionalLight position={[5, 5, 5]} />
        <SpinningCube />
      </Canvas>
    </div>
  );
};

export default LoadingScreen;
